import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Fassaden = () => {
  const pageData = {
    title: 'FASSADEN',
    subtitle: 'Repräsentative Außenwirkung',
    description: 'Professionelle Fassadengestaltung und -sanierung. Der erste Eindruck zählt – wir machen Ihre Fassade zum Blickfang.',
    heroImage: 'https://images.unsplash.com/photo-1672847863750-1865a99b1787?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGZhY2FkZSUyMHNjYWZmb2xkaW5nJTIwcmVub3ZhdGlvbiUyMHBhaW50aW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NjI5OTUxfDA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Fassadenanstrich', description: 'Wetterbeständige Anstriche mit langlebigen Farben.' },
      { title: 'Sanierung', description: 'Komplette Fassadensanierung alter Gebäude.' },
      { title: 'Verputzen', description: 'Neuverputzung oder Ausbesserung bestehender Putzflächen.' },
      { title: 'Dämmung', description: 'Wärmedämmverbundsysteme für Energieeffizienz.' },
      { title: 'Risse reparieren', description: 'Fachgerechte Rissreparatur und Untergrundvorbereitung.' },
      { title: 'Schutzanstriche', description: 'Hydrophobierende Anstriche gegen Feuchtigkeit.' }
    ],
    benefits: [
      'Langlebiger Witterungsschutz',
      'Wertsteigerung der Immobilie',
      'Verbesserte Energieeffizienz',
      'Professionelle Farbberatung',
      'Alle Arbeiten aus einer Hand',
      'Gerüststellung inklusive'
    ],
    process: [
      { title: 'Begutachtung', description: 'Zustandsanalyse und Beratung vor Ort.' },
      { title: 'Vorbereitung', description: 'Reinigung, Reparaturen und Grundierung.' },
      { title: 'Beschichtung', description: 'Auftrag der Farbe oder des Putzes.' },
      { title: 'Abnahme', description: 'Finale Kontrolle und Abnahme mit Ihnen.' }
    ],
    gallery: [
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/anpdmeaz_WhatsApp%20Image%202026-05-01%20at%2010.45.53%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/5dlwddz3_WhatsApp%20Image%202026-05-01%20at%2010.45.53%20%283%29.jpeg'
    ],
    metaKeywords: 'Fassadenbau Graubünden, Fassadenanstrich Cazis, Fassadensanierung Schweiz'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Fassaden;